<template>
  <Feed
    :item-id="itemId"
    :title="title"
    order-by="followers"
    v-bind="$attrs"
  />
</template>

<script>
import Feed from '@/components/cards/models/Feed';

export default {
  name: 'TopPostsByFollowers',
  components: {
    Feed,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
